/**
 * Combined editor bar with file tabs, mode switcher, page info, and format controls.
 * Consolidates InfoBar, ChatLevelSwitcher, and TextControlBar into a single bar.
 */

import "../../css/rc-tabs.css";

import { measures } from "@quickpoint.me/shared";
import { useRecoilValue } from "recoil";
import { IsInPortrait } from "../../state/selectors";

import BoldControl from "../controls/BoldControl";
import ItalicControl from "../controls/ItalicControl";
import MarkdownToJadleControl from "../controls/MarkdownToJadleControl";
import UnderlineControl from "../controls/UnderlineControl";
import UndoControl from "../controls/UndoControl";
import ChatLevelSwitcher from "../chat/ChatLevelSwitcher";

import styled from "styled-components";


const StyledEditorBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: ${measures.textControlBar.landscape.height};
  background-color: ${(props) => props.theme.backgroundColor};
  flex-shrink: 0;
  min-width: 0;
  position: relative;
`;

const StyledLeftSection = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  height: 100%;
  padding-left: ${measures.editor.landscape.gutter};
`;

const StyledSpacer = styled.div`
  flex: 1;
  height: 100%;
  border-bottom: 1px solid ${(props) => props.theme.navigationFrame};
`;

const StyledModeAndControls = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: 100%;
  gap: 0.5svw;
  padding-right: ${measures.topBar.inlineMargin.landscape};
  border-bottom: 1px solid ${(props) => props.theme.navigationFrame};
`;

const StyledFormatControls = styled.div`
  display: flex;
  align-items: center;
  border-left: 1px solid ${(props) => props.theme.navigationFrame};
  padding-left: 0.3svw;
  height: 100%;
`;

function EditorBar() {
	const isInPortrait = useRecoilValue(IsInPortrait);

	// portrait keeps the level tabs (the whole 3-level editor hangs off them)
	// but drops the formatting controls — no room, and they target the
	// landscape structure-editing workflow
	return (
		<StyledEditorBar>
			<StyledLeftSection>
				<ChatLevelSwitcher />
				<StyledSpacer />
			</StyledLeftSection>

			{!isInPortrait && (
				<StyledModeAndControls>
					<BoldControl />
					<ItalicControl />
					<UnderlineControl />
					<StyledFormatControls>
						<UndoControl />
						<MarkdownToJadleControl />
					</StyledFormatControls>
				</StyledModeAndControls>
			)}
		</StyledEditorBar>
	);
}

export default EditorBar;
